
<div *ngIf="!editDetails">
<div class="row">
  <div class="col-12 text-right edit-btn mt-3">
    <ng-container *ngIf="!viewMode && showEditButton">
      <button class="back-button button-width-icon-left btn-pos-top-right" (click)="handleEdit(containerId)">
        <!-- <img src="../../../../../assets/images/edit.png" alt="" /> -->
        <i class="fa fa-pencil"></i>
        Edit
      </button>
    </ng-container>
  </div>
</div>
<ng-container *ngFor="let bankDetail of bankDetails; let i = index">
<div *ngIf="i === containerId">
<div class="row row-cols-5">
    <div class="col mb-2">
        <p class="label-light m-0">Bank Name</p>
        <label class="label-dark wrap-word">{{
            bankDetail?.bankName ? bankDetail?.bankName : "--"
            }}</label>
    </div>
    <div class="col mb-2">
      <p class="label-light m-0">Routing Type</p>
      <label class="label-dark wrap-word">
          {{
          bankDetail?.routingType ? bankDetail?.routingType : "--"
          }}</label>
  </div>
    <div class="col mb-2">
        <p class="label-light m-0">Routing Number</p>
        <label class="label-dark wrap-word">
            {{
            bankDetail?.routingNumber ? bankDetail?.routingNumber : "--"
            }}</label>
    </div>
    <div class="col mb-2">
        <p class="label-light m-0">Account Type</p>
        <label class="label-dark wrap-word">{{
            bankDetail?.accountType ? bankDetail?.accountType : "--"
            }}</label>
    </div>
    <div class="col mb-2">
        <p class="label-light m-0">Account Number</p>
        <label class="label-dark wrap-word">{{
            bankDetail?.accountNumber ? bankDetail?.accountNumber : "--"
            }}</label>
    </div>
    <div class="col mb-2">
        <p class="label-light m-0">Branch Name</p>
        <label class="label-dark wrap-word">{{
            bankDetail?.branchName ? bankDetail?.branchName : "--"
            }}</label>
    </div>
    <div class="col mb-2" *ngIf="countryCode !== 'USA'">
        <p class="label-light m-0">IFSC Code</p>
        <label class="label-dark wrap-word">{{
            bankDetail?.ifscCode ? bankDetail?.ifscCode : "--"
            }}</label>
    </div>
    <div class="col mb-2" *ngIf="countryCode !== 'USA'">
        <p class="label-light m-0">Bank Nominee Name</p>
        <label class="label-dark wrap-word">{{
            bankDetail?.bankNomineeName ? bankDetail?.bankNomineeName : "--"
            }}</label>
    </div>
    <div class="col mb-2" *ngIf="countryCode !== 'USA'">
        <p class="label-light m-0">Nominee DOB</p>
        <label class="label-dark wrap-word">{{
            bankDetail?.nomineeDob ? bankDetail?.nomineeDob : "--"
            }}</label>
    </div>
    <div class="col-4 mb-2" *ngIf="countryCode !== 'USA'">
        <p class="label-light m-0">Relationship with Nominee</p>
        <label class="label-dark wrap-word">{{
            bankDetail?.relationshipWithNominee ? bankDetail?.relationshipWithNominee : "--"
            }}</label>
    </div>

</div>
<div class="col-6" *ngIf="bankDetails !== null">
    <div>
        <p class="label-cls mb-2">In Case, Bank Details readily not available, provides a valid reason
        </p>
        <textarea readonly="true" style="width: 100%" [(ngModel)]="bankDetail.validReason"></textarea>
    </div>
</div>

<div class="row">
    <div class="col-md-12 my-3">
        <h6 class="labelText mt-2">Uploaded Bank Document</h6>
        <p-table [value]="bankDetail?.file" [resizableColumns]="true" styleClass="p-datatable-gridlines">
            <ng-template pTemplate="header">
                <tr>
                  <!-- <th style="width:5%"><p-checkbox *ngIf="bulkDownloadCheckboxes['Experience']" value="true" inputId="documentTypeExperience" binary="true"  name="groupnameExperience" [(ngModel)]="bulkDownloadCheckboxes['Experience']['isAllSelected']"
                      (onChange)="selectAllDocs($event,bulkDownloadCheckboxes['Experience'])" [disabled]="!loadData.Experience?.length"></p-checkbox></th> -->
                    <th>Type</th>
                    <th>Name</th>
                    <th>Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-loadData>
                <tr>
                  <!-- <td style="width:5%"><p-checkbox *ngIf="bulkDownloadCheckboxes['Experience']" value="true" inputId="documentTypeExperience{{loadData?.id}}" binary="true" name="groupname{{loadData?.id}}" [(ngModel)]="bulkDownloadCheckboxes['Experience']['childItems'][loadData['itemIndex']]['isSelected']" (onChange)="selectDoc($event,bulkDownloadCheckboxes['Experience'])"></p-checkbox></td> -->
                  <td>{{loadData?.fileCategory}}</td>
                    <td>{{loadData?.fileName}}</td>
                    <td>
                        <div class="row" *ngIf="loadData.fileCategory !== null && loadData.fileName !== null">
                            <div><i class="fa fa-download pr-2 icn" title="Download" (click)="download(loadData)"></i> </div>
                            <div> <i class="fa fa-trash icn" title="Delete" (click)="deleteDoc(loadData)"></i> </div>
                            </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-loadData>
                <tr>
                  <td [attr.colspan]="3">
                     No records found
                  </td>
                </tr>
              </ng-template>
        </p-table>
    </div>
</div>
</div>
</ng-container>
</div>
<div *ngIf="editDetails" class="edit-bank-details">
    <form [formGroup]="bankDetailsForm" #f="ngForm"
      (ngSubmit)="saveBankData()">
      <div class="row mt-2">
        <div class="col-3">
          <p class="label-cls text-label" [class.required]="beneficiaryType==='self'">Bank Name</p>
          <input type="text" class="im-input" [ngClass]="{
              'im-input-error':
                (bankDetailsForm.get('bankName').touched || submitted) &&
                bankDetailsForm.get('bankName').errors?.required || bankDetailsForm.get('bankName').hasError('maxLength')
            }" pattern="^[a-zA-Z ]*$" formControlName="bankName" placeholder="Enter your Bank Name" />
          <span class="invalid-message" *ngIf="
              (bankDetailsForm.get('bankName').touched || submitted) &&
              bankDetailsForm.get('bankName').errors?.required
            ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
          <span class="invalid-message" *ngIf="
              (bankDetailsForm.get('bankName').touched || submitted) &&
              bankDetailsForm.get('bankName').errors?.pattern
            ">
            {{ getGlobalErrorMessages("ALPHABETS_ONLY") }}
          </span>
          <span class="invalid-message" *ngIf="bankDetailsForm.get('bankName').hasError('maxLength')">
            {{ getGlobalErrorMessages("MAXLENGTH") }} 20 Characters
          </span>
        </div>
        <div class="col-3"> <!-- *ngIf="routingTypes.length > 0"-->
          <p class="label-cls" [class.required]="beneficiaryType==='self'">Routing Type</p>
          <div class="dd-position">
          <p-dropdown [options]="routingTypes" formControlName="routingType"
          optionLabel="name" optionValue="name"
          placeholder="Select Routing Type" [style]="{'width':'100%'}"></p-dropdown>
          <span class="invalid-message" *ngIf="
          (bankDetailsForm.get('routingType').touched || submitted) &&
          bankDetailsForm.get('routingType').errors?.pattern">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
        </div>
        </div>
        <div class="col-3">
          <p class="label-cls text-label">Routing Number</p>
          <input type="text" class="im-input" [ngClass]="{
              'im-input-error':
                (bankDetailsForm.get('routingNumber').touched || submitted) &&
                bankDetailsForm.get('routingNumber').errors?.pattern || bankDetailsForm.get('routingNumber').hasError('maxLength')
            }" pattern="^[0-9]*$" formControlName="routingNumber" maxlength="32" placeholder="Enter your Routing Number" />
            <span class="invalid-message" *ngIf="
                        (bankDetailsForm.get('routingNumber').touched || submitted) &&
                        bankDetailsForm.get('routingNumber').errors?.required
                      ">
              {{ getGlobalErrorMessages("REQUIRED") }}
            </span>
            <span class="invalid-message" *ngIf="
              (bankDetailsForm.get('routingNumber').touched || submitted) &&
              bankDetailsForm.get('routingNumber').errors?.pattern
            ">
            {{ getGlobalErrorMessages("NUMBER_ONLY") }}
          </span>
          <span class="invalid-message" *ngIf="bankDetailsForm.get('routingNumber').hasError('maxLength')">
            {{ getGlobalErrorMessages("MAXLENGTH") }} 30 Numbers
          </span>
        </div>
        <div class="col-3">
          <p class="label-cls" [class.required]="beneficiaryType==='self'">Account Type</p>
          <div class="dd-position">
          <p-dropdown [options]="accountTypes" formControlName="accountType"
          optionLabel="name" optionValue="name"
          placeholder="Select Account Type" [style]="{'width':'100%'}"></p-dropdown>
          <span class="invalid-message" *ngIf="
          (bankDetailsForm.get('accountType').touched || submitted) &&
          bankDetailsForm.get('accountType').errors?.pattern">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
        </div>
        </div>
        <div class="col-3">
          <p class="label-cls text-label" [class.required]="beneficiaryType==='self'">Account Number</p>
          <input type="text" class="im-input" [ngClass]="{
              'im-input-error':
                (bankDetailsForm.get('accountNumber').touched || submitted) &&
                bankDetailsForm.get('accountNumber').errors?.required || bankDetailsForm.get('accountNumber').hasError('maxLength')
            }" pattern="^[0-9]*$" formControlName="accountNumber" placeholder="Enter Account Number" />
          <span class="invalid-message" *ngIf="
              (bankDetailsForm.get('accountNumber').touched || submitted) &&
              bankDetailsForm.get('accountNumber').errors?.required
            ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
          <span class="invalid-message" *ngIf="
              (bankDetailsForm.get('accountNumber').touched || submitted) &&
              bankDetailsForm.get('accountNumber').errors?.pattern
            ">
            {{ getGlobalErrorMessages("NUMBER_ONLY") }}
          </span>
          <span class="invalid-message" *ngIf="bankDetailsForm.get('accountNumber').hasError('maxLength')">
            {{ getGlobalErrorMessages("MAXLENGTH") }} 18 Numbers
          </span>
        </div>
        <div class="col-3">
          <p class="label-cls text-label" [class.required]="beneficiaryType==='self'">Branch Name</p>
          <input type="text" class="im-input" [ngClass]="{
              'im-input-error':
                (bankDetailsForm.get('branchName').touched || submitted) &&
                bankDetailsForm.get('branchName').errors?.required || bankDetailsForm.get('branchName').hasError('maxLength')
            }" pattern="^[a-zA-Z ]*$" formControlName="branchName" placeholder="Enter Branch Name" />
          <span class="invalid-message" *ngIf="
              (bankDetailsForm.get('branchName').touched || submitted) &&
              bankDetailsForm.get('branchName').errors?.required
            ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
          <span class="invalid-message" *ngIf="
              (bankDetailsForm.get('branchName').touched || submitted) &&
              bankDetailsForm.get('branchName').errors?.pattern
            ">
            {{ getGlobalErrorMessages("ALPHABETS_ONLY") }}
          </span>
          <span class="invalid-message" *ngIf="bankDetailsForm.get('branchName').hasError('maxLength')">
            {{ getGlobalErrorMessages("MAXLENGTH") }} 20 Characters
          </span>
        </div>
      </div>
      <div class="row mt-2" *ngIf="countryCode !== 'USA'">
        <div class="col-3">
          <p class="label-cls text-label" [class.required]="beneficiaryType==='self'">IFSC Code</p>
          <input type="text" class="im-input" [ngClass]="{
              'im-input-error':
                (bankDetailsForm.get('ifscCode').touched || submitted) &&
                bankDetailsForm.get('ifscCode').errors?.required || bankDetailsForm.get('ifscCode').hasError('maxLength')
            }" pattern="^[A-Za-z0-9]*$" formControlName="ifscCode" placeholder="Enter Account Number" />
          <span class="invalid-message" *ngIf="
              (bankDetailsForm.get('ifscCode').touched || submitted) &&
              bankDetailsForm.get('ifscCode').errors?.required
            ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
          <span class="invalid-message" *ngIf="
              (bankDetailsForm.get('ifscCode').touched || submitted) &&
              bankDetailsForm.get('ifscCode').errors?.pattern
            ">
            {{ getGlobalErrorMessages("INVALID_FORMAT") }}
          </span>
          <span class="invalid-message" *ngIf="bankDetailsForm.get('ifscCode').hasError('maxLength')">
            IFSC Code must not be greater than 11 characters.
          </span>
        </div>
        <div class="col-3">
          <p class="label-cls text-label" [class.required]="beneficiaryType==='self'">Bank Nominee Name</p>
          <input type="text" class="im-input" [ngClass]="{
              'im-input-error':
                (bankDetailsForm.get('bankNomineeName').touched || submitted) &&
                bankDetailsForm.get('bankNomineeName').errors?.required || bankDetailsForm.get('bankNomineeName').hasError('maxLength')
            }" pattern="^[a-zA-Z ]*$" formControlName="bankNomineeName" placeholder="Enter Branch Name" />
          <span class="invalid-message" *ngIf="
              (bankDetailsForm.get('bankNomineeName').touched || submitted) &&
              bankDetailsForm.get('bankNomineeName').errors?.required
            ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
          <span class="invalid-message" *ngIf="
              (bankDetailsForm.get('bankNomineeName').touched || submitted) &&
              bankDetailsForm.get('bankNomineeName').errors?.pattern
            ">
            {{ getGlobalErrorMessages("ALPHABETS_ONLY") }}
          </span>
          <span class="invalid-message" *ngIf="bankDetailsForm.get('bankNomineeName').hasError('maxLength')">
            {{ getGlobalErrorMessages("MAXLENGTH") }} 20 Characters
          </span>
        </div>
        <div class="col-3">
          <p class="label-cls">Nominee DOB</p>
          <div class="dd-position">
          <mat-form-field appearance="outline" class="mt-0 date-field custom-datepicker">
            <input formControlName="nomineeDob" matInput min="1920-12-31" [max]="currentDate" [matDatepicker]="nomineeDob"
              placeholder="MM/DD/YYYY" (click)="nomineeDob.open()" />
            <mat-datepicker-toggle matSuffix [for]="nomineeDob"></mat-datepicker-toggle>
            <mat-datepicker #nomineeDob></mat-datepicker>
          </mat-form-field>
          <span class="invalid-message" *ngIf="
              (bankDetailsForm.get('nomineeDob').touched || submitted) &&
              bankDetailsForm.get('nomineeDob').errors?.required &&
              !bankDetailsForm.get('nomineeDob').errors?.matDatepickerParse
            ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
          <span class="invalid-message" *ngIf="
              (bankDetailsForm.get('nomineeDob').touched || submitted) &&
              bankDetailsForm.get('nomineeDob').errors?.required &&
              bankDetailsForm.get('nomineeDob').errors?.matDatepickerParse
            ">
            {{ getGlobalErrorMessages("INVALID_FORMAT") }}
          </span>
          <span class="invalid-message" *ngIf="
              (bankDetailsForm.get('nomineeDob').touched || submitted) &&
              bankDetailsForm.get('nomineeDob').errors?.currentDateError
            ">
            {{ getGlobalErrorMessages("INVALID_DATE") }}
          </span>
          <span class="invalid-message" *ngIf="
              (bankDetailsForm.get('nomineeDob').touched || submitted) &&
              bankDetailsForm.get('nomineeDob').errors?.patternError
            ">
            {{ getGlobalErrorMessages("INVALID_FORMAT") }}
          </span>
        </div>
        </div>
        <div class="col-3">
          <p class="label-cls text-label" [class.required]="beneficiaryType==='self'">Relationship with Nominee</p>
          <input type="text" class="im-input" [ngClass]="{
              'im-input-error':
                (bankDetailsForm.get('relationshipWithNominee').touched || submitted) &&
                bankDetailsForm.get('relationshipWithNominee').errors?.required || bankDetailsForm.get('relationshipWithNominee').hasError('maxLength')
            }" pattern="^[a-zA-Z ]*$" formControlName="relationshipWithNominee" placeholder="Enter Branch Name" />
          <span class="invalid-message" *ngIf="
              (bankDetailsForm.get('relationshipWithNominee').touched || submitted) &&
              bankDetailsForm.get('relationshipWithNominee').errors?.required
            ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
          <span class="invalid-message" *ngIf="
              (bankDetailsForm.get('relationshipWithNominee').touched || submitted) &&
              bankDetailsForm.get('relationshipWithNominee').errors?.pattern
            ">
            {{ getGlobalErrorMessages("ALPHABETS_ONLY") }}
          </span>
          <span class="invalid-message" *ngIf="bankDetailsForm.get('relationshipWithNominee').hasError('maxLength')">
            {{ getGlobalErrorMessages("MAXLENGTH") }} 20 Characters
          </span>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-6">
          <p class="label-cls mb-2">In Case, Bank Details readily not available, provide a valid reason</p>
          <textarea style="width: 100%" formControlName="validReason" maxlength="100"></textarea>
          <span class="invalid-message" *ngIf="
                    (bankDetailsForm.get('validReason').touched || submitted) &&
                    bankDetailsForm.get('validReason').errors?.required
                ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
        </div>
      </div>
      <div class="row mt-4">
        <p *ngIf="!viewMode" class="lbl-text-2">Add the Document</p>
        <app-file-upload style="width: 100%" [configurations]="documentFileUploadConfigurations" [containerId]="bankDetails[containerId].id"></app-file-upload>
      </div>
      <div class="row">
        <div class="col-12 text-right">
          <button class="back-button d-inline-flex align-items-center pr-3 pl-3 mr-3" *ngIf="bankUpdateProfile"
            (click)="backToTask()">
            <i class="fa fa-chevron-circle-left pr-1" aria-hidden="true"></i>
            Back
          </button>
          <lib-save-as-draft *ngIf="detailsAbout.showDetailFor === 'self'" class="mr-3"
            (onClickSaveAsDraft)="saveAsDraft($event)" [showSaveIcon]="true"
            [formToBeSaved]="bankDetailsForm"></lib-save-as-draft>
          <button type="submit" class="btn btn-success button-width-icon-left mr-3"
            [disabled]="bankDetailsForm.invalid" [ngClass]="{'invalidBtn': bankDetailsForm.invalid }">
            <i class="fa fa-floppy-o"></i>
            Save
          </button>
          <button *ngIf="!editModeVal" type="button" class="back-button button-width-icon-left"
            (click)="clearProfileData(f)">
            <i class="fa fa-times-circle"></i>
            Cancel
          </button>
        </div>
      </div>
    </form>
  </div>